var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyMapNactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.0968C11.13 5.0968 8 8.2268 8 12.0968C8 16.2668 12.42 22.0168 14.24 24.2068C14.64 24.6868 15.37 24.6868 15.77 24.2068C17.58 22.0168 22 16.2668 22 12.0968C22 8.2268 18.87 5.0968 15 5.0968ZM15 14.5968C13.62 14.5968 12.5 13.4768 12.5 12.0968C12.5 10.7168 13.62 9.5968 15 9.5968C16.38 9.5968 17.5 10.7168 17.5 12.0968C17.5 13.4768 16.38 14.5968 15 14.5968Z",
    fill: "#ADB8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyMapNactive);
export default __webpack_public_path__ + "static/media/company_map_nactive.2cba463e06aa690ee0914730d029b59f.svg";
export { ForwardRef as ReactComponent };